<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="centerImage"><img alt="images" id="img10" src="images/img10.jpg"/></p>
<p class="caption2">Major Forts and Encounter Sites, 1864-1898</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_introduction16.vue?eb973c3e